const scrollbarToBrowserBottom = () => {
  // 获取网页可见区域宽度
  const browserHeight = document.documentElement.clientHeight;
  // 滚动条的高度
  const scrollTop =
    document.documentElement.scrollTop || document.body.scrollTop;
  // 文本的高度
  const txtHeight = document.body.offsetHeight;

  // 滚动条在底部的条件  browserHeight + scrollTop  ===  txtHeight
  // console.log(browserHeight, scrollTop, txtHeight);

  const range = txtHeight - (browserHeight + scrollTop);
  return range;
};

const throttle = (fn, interval = 3000) => {
  let canRun = true;
  return function () {
    if (!canRun) return;
    canRun = false;
    setTimeout(() => {
      fn.apply(this, arguments);
      canRun = true;
    }, interval);
  };
};

const debounce = (fn, interval = 500) => {
  let timeout = null;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      fn.apply(this, arguments);
    }, interval);
  };
};
const subStrNum = (str, len) => {
  const strLen = str.length;
  let strCut = '';
  let strLength = 0;
  for (let i = 0; i < strLen; i++) {
    const charStr = str.charAt(i); // 使用charAt获取单个字符；
    strLength++;
    if (encodeURI(charStr).length > 4) {
      // 使用encodeURI获取编码长度
      strLength++;
    }
    strCut = strCut.concat(charStr); // 单个字符进行合并
    if (strLength >= len) {
      strCut = strCut.concat('...'); // 大于指定长度后合并'...'并返回此字符串
      return strCut;
    }
  }
  if (strLength < len) {
    return str;
  }
};

/**
 * @description 设置 cookie
 * @param { String } key 键
 * @param { String } val 值
 * @param { Number } t 过期时间如果为空默认一年
 */
const setCookie = (key, val, t = 365 * 24 * 60 * 60 * 1000) => {
  const oDate = new Date();
  oDate.setDate(oDate.getDate() + t);
  document.cookie = `${key}=${val}; expires=${oDate.toDateString()}`;
};

/**
 * @description 获取 cookie 值
 * @param { String } name 字段名称
 */
const getCookie = name => {
  let arr;
  const reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
  if ((arr = document.cookie.match(reg))) {
    return unescape(arr[2]);
  } else {
    return null;
  }
};

const autoprefixer = function (style) {
  if (typeof style !== 'object') return style;
  const rules = ['transform', 'transition', 'animation'];
  const prefixes = ['ms-', 'webkit-'];
  rules.forEach(rule => {
    const value = style[rule];
    if (rule && value) {
      prefixes.forEach(prefix => {
        style[prefix + rule] = value;
      });
    }
  });
  return style;
};

/**
 * @description 需要刷新页面的路由
 * @returns { Boolean } 判断结果
 */
const reloadRoute = () => {
  return [
    '/member',
    '/p/',
    '/album/',
    '/my/',
    '/chiefCircle',
    '/community/post',
    '/community/topics/',
    '/chiefChatroom',
    '/hotspot/',
    '/chatroom/',
    '/activity/',
    '/huiluyan/',
  ].some(item => location.pathname.includes(item));
};

/**
 * @description 消息文本格式化
 * @param { String } str 格式化文本
 * @param { String } type 格式转换类型 1.link(链接) 2.text(文本)
 * @returns { String } 格式化文本
 */
const formatMsg = (str, type = 'link') => {
  const matchStock = str.match(/<\[\$[^<>\$\[\]]*\$\]>/g);
  if (matchStock) {
    // 匹配指数消息
    matchStock.forEach(item => {
      const mid = item.slice(3, -3);
      const arr = mid.split(/[\(\)]/);
      const code = arr[1];
      const text = arr[0];
      const url =
        type === 'link'
          ? `<a class="link" href="/stock/${code}" target="_blank"><i class="g-icon-link"></i>${text}</a>`
          : `${text}(${code})`;
      str = str.replace(item, url);
    });
  }
  const matchLink = str.match(
    /<\[\[[^\(\)\[\]]*\]\(http[s]?:\/\/[^<>\[\]]*\)\]>/g
  );
  if (matchLink) {
    // 文章跳转路径
    matchLink.forEach(item => {
      const text = item.match(/<\[\[[^\(\)\[\]]*\]/)[0].slice(3, -1);
      const link = item.match(/\(http[s]?:\/\/[^<>\[\]]*\)\]>/)[0].slice(1, -3);
      const url =
        type === 'link'
          ? `<a class="link" href="${link}" target="_blank"><i class="g-icon-link"></i>${text}</a>`
          : `${text} ${link}`;
      str = str.replace(item, url);
    });
  }
  str = str.replace(/\r?\n/g, '<br>');
  str = str.replace(/<script.*>.*<\/script>/gi, ''); // 过滤 script 标签
  return str;
};

/**
 * @description 格式化聊天消息
 * @param { string } str 格式化文本
 */
const formatCommit = (str, isLineFeed = true, changeLine = true) => {
  if (changeLine) {
    if (isLineFeed) {
      str = str.replace(/\r?\n/g, '<br>');
    } else {
      str = str.replace(/\r?\n+/g, '<br>');
    }
  }
  str = str.replace(/<script.*>.*<\/script>/gi, ''); // 过滤 script 标签
  const matchType = str.match(/<\[(.+?)\]>/g);
  if (matchType) {
    matchType.forEach(item => {
      const text = item.slice(2, -2);
      let url;
      if (text.match(/\[(.+?)\)/)) {
        // 链接
        url = formatLink(text);
      } else if (text.match(/\$(.+?)\$/)) {
        // 股票
        url = formatStock(text);
      } else if (text.match(/\@(.+?)/)) {
        // 用户
        url = formatUser(text);
      } else if (text.match(/\%(.+?)\%/)) {
        // 组合
        url = formatPortfolio(text);
      } else if (text.match(/image\((.+?)\)/)) {
        // 图片
        url = formatImage(text);
      }
      str = str.replace(item, url);
    });
  }
  return str;
};

/**
 * @description 格式化链接
 * @param { string } str 匹配字符
 */
const formatLink = str => {
  let url = null;
  if (str.match(/\[([\s\S]*)\]/) && str.match(/\(([\s\S]*)\)/)) {
    const name = str.match(/\[([\s\S]*)\]/)[1];
    let link = str.match(/\(([\s\S]*)\)/)[1];
    if (!link.includes('http')) {
      link = 'https://' + link;
    }
    url = `<a class="link" selected-n="link" contenteditable="false" href="${link}" target="_blank"><i class="g-icon-link"></i>${name}</a>`;
  }
  return url || str;
};

/**
 * @description 格式化股票
 * @param { string } str 匹配字符
 */
const formatStock = str => {
  if (str.match(/\(([\s\S]*)\)/)) {
    const link = str.match(/\(([\s\S]*)\)/)[1];
    return `<a class="link" selected-n="stock" contenteditable="false" href="/stock/${link}" target="_blank">${str}</a>`;
  }
};

/**
 * @description 格式化用户
 * @param { string } str 匹配字符
 */
const formatUser = str => {
  const arr = str.split(',');
  const name = arr[0];
  const id = arr[1];
  return `<a class="link" selected-n="user" contenteditable="false" id="user-${id}" href="/user/${id}" target="_blank">${name}</a>`;
};

/**
 * @description 格式化组合
 * @param { string } str 匹配字符
 */
const formatPortfolio = str => {
  if (str.match(/\(([\s\S]*)\)/)) {
    const link = str.match(/\(([\s\S]*)\)/)[1];
    return `<a class="link" selected-n="portfolio" contenteditable="false" href="/portfolio/${link}" target="_blank">$${str.substring(
      1,
      str.length - 1
    )}$</a>`;
  }
};

/**
 * @description 格式化图片
 * @param { string } str 匹配字符
 */
const formatImage = str => {
  if (str.match(/\(([\s\S]*)\)/)) {
    const link = str.match(/\(([\s\S]*)\)/)[1];
    return `<span class="link" contenteditable="false" image-url="${link}"><i class="g-icon-image"></i>查看图片</span>`;
  }
};

const ObjAndNotNull = obj => {
  return (typeof obj === 'object' || typeof obj === 'function') && obj !== null;
};

const cloneDeep = (obj, hash = new WeakMap()) => {
  // 处理循环引用
  if (hash.has(obj)) return hash.get(obj);

  // 处理特殊的数据

  const types = [Date, RegExp, Set, Map, WeakSet, WeakMap];
  if (types.includes(obj.constructor)) return new obj.constructor(obj);

  const cloneObj = Object.create(
    Object.getPrototypeOf(obj),
    Object.getOwnPropertyDescriptors(obj)
  );

  hash.set(obj, cloneObj);

  for (const key of Reflect.ownKeys(obj)) {
    cloneObj[key] =
      ObjAndNotNull(obj[key]) && typeof obj[key] !== 'function'
        ? cloneDeep(obj[key], hash)
        : obj[key];
  }

  return cloneObj;
};

/**
 * @description 秒格式化
 * @param { number } time 时间
 */
const secondFormat = time => {
  const h = String(Math.floor(time / 3600));
  const m = String(Math.floor((time / 60) % 60));
  const s = String(Math.floor(time % 60));
  let str = `${m.padStart(2, '0')}:${s.padStart(2, '0')}`;
  if (h > 0) {
    str = `${h.padStart(2, '0')}:${str}`;
  }
  return str;
};

export const VoteFromNow = unixTime => {
  // 小时 = 毫秒数
  const HOUR = 60 * 60 * 1000;
  // 分钟 = 毫秒数
  const MINUTE = 60 * 1000;
  // 当前时间
  const currentTimes = new Date().getTime();
  // 时间差
  const x = unixTime * 1000 - currentTimes;
  const h = x / HOUR;
  if (h >= 1) {
    return `${Math.floor(h)}小时`;
  } else {
    // 换算分钟
    const m = x / MINUTE;
    return `${Math.floor(m)}分钟`;
  }
};
/**
 * @description 格式化文件大小
 * @param { number } a 文件大小
 * @param { number } b 小数点后几位
 * @returns { string } 格式化文件
 */
const formatBytes = (a, b) => {
  if (a === 0) return '0 Bytes';
  const c = 1024;
  const d = b || 2;
  const e = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const f = Math.floor(Math.log(a) / Math.log(c));
  return parseFloat((a / Math.pow(c, f)).toFixed(d)) + ' ' + e[f];
};

const BaiduEvent = data => {
  window._hmt &&
    window._hmt.push([
      '_trackEvent',
      data.category,
      data.event || 'click',
      data.label,
      data.value || '',
    ]);
};
const formatNumber = n => {
  const plusOrMinus = n >= 0 ? '' : '-';
  let num = Math.abs(n);
  if (num < 10000) {
    num = plusOrMinus + num;
  } else if (num < 1e8) {
    num = plusOrMinus + (num / 1e4).toFixed(2) + '万';
  } else if (num < 1e12) {
    num = plusOrMinus + (num / 1e8).toFixed(2) + '亿';
  } else {
    num = plusOrMinus + (num / 1e12).toFixed(2) + '万亿';
  }
  return num;
};
export {
  scrollbarToBrowserBottom,
  throttle,
  debounce,
  subStrNum,
  setCookie,
  getCookie,
  autoprefixer,
  reloadRoute,
  formatMsg,
  formatCommit,
  cloneDeep,
  secondFormat,
  formatBytes,
  BaiduEvent,
  formatNumber,
};
